// extracted by mini-css-extract-plugin
export default {"buttonBack":"ButtonBack_buttonBack__BGz5l","btn":"ButtonBack_btn__NGnEA"};